import { SHOW_STATS, STATS } from "../../content/site";
import { Reveal } from "./Kit";

export const Stats = () => {
  if (!SHOW_STATS) return null;
  return (
    <section data-testid="stats-section" aria-label="Key facts" className="border-y hairline">
      <div className="container-x grid gap-10 py-16 md:grid-cols-3">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 80} data-testid={`stat-${i + 1}`}>
            <p className="font-display text-5xl sm:text-6xl font-semibold tracking-[-0.03em] text-gold">{s.value}</p>
            <p className="mt-3 max-w-xs text-[15px] text-paper/85">{s.label}</p>
            {s.note && <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.16em] text-mist">{s.note}</p>}
          </Reveal>
        ))}
      </div>
    </section>
  );
};
